import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { sortBy } from 'lodash-es';

export interface OutrightsOptionGroups {
    playerId: number;
    firstColumnPrice: number;
    options: EventOption[];
}

export function getOutrightsGrouping(eventOptions: EventOption[]): OutrightsOptionGroups[] {
    const playerOutrightsData: { [playerId: string]: OutrightsOptionGroups } = {};
    const groupedData: OutrightsOptionGroups[] = [];
    const key: keyof EventOption = 'playerId';
    eventOptions.forEach((eventOption) => {
        const playerId = eventOption[key]!;
        if (!(playerId in playerOutrightsData)) {
            const price = eventOptions.find(
                (evt) => evt.optionColumnId === eventOptions[0].optionColumnId && evt.playerId === playerId && evt.visible === true,
            )?.nativePrice;
            const firstColumnPrice = price?.odds.toNumber() ?? 0;
            const playerData = {
                playerId,
                firstColumnPrice,
                options: [],
            };
            playerOutrightsData[playerId] = playerData;
            groupedData.push(playerData);
        }
        playerOutrightsData[playerId].options.push(eventOption);
    });

    const firstColumnIdsWithPrice = sortBy([...groupedData.filter((x) => x.firstColumnPrice !== 0)], 'firstColumnPrice');
    const outrightsOrder = new Map(firstColumnIdsWithPrice.map((val, index) => [val.firstColumnPrice, index]));
    const orderedData = sortBy(groupedData, (t) => outrightsOrder.get(t.firstColumnPrice) ?? 9999);

    return orderedData;
}
